import { render, staticRenderFns } from "./MainCenter.vue?vue&type=template&id=38abe882&scoped=true"
import script from "./MainCenter.vue?vue&type=script&lang=js"
export * from "./MainCenter.vue?vue&type=script&lang=js"
import style0 from "./MainCenter.vue?vue&type=style&index=0&id=38abe882&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38abe882",
  null
  
)

export default component.exports